import request from '@/utils/request'


// 查询用户身体异常记录列表
export function listJoe(query) {
  return request({
    url: '/joe/dealer-record/list',
    method: 'get',
    params: query
  })
}

// 查询用户身体异常记录分页
export function pageJoe(query) {
  return request({
    url: '/joe/dealer-record/page',
    method: 'get',
    params: query
  })
}

// 查询用户身体异常记录详细
export function getJoe(data) {
  return request({
    url: '/joe/dealer-record/detail',
    method: 'get',
    params: data
  })
}

// 新增用户身体异常记录
export function addJoe(data) {
  return request({
    url: '/joe/dealer-record/add',
    method: 'post',
    data: data
  })
}

// 修改用户身体异常记录
export function updateJoe(data) {
  return request({
    url: '/joe/dealer-record/edit',
    method: 'post',
    data: data
  })
}

// 删除用户身体异常记录
export function delJoe(data) {
  return request({
    url: '/joe/dealer-record/delete',
    method: 'post',
    data: data
  })
}
